import React from 'react';
import { Box, Typography } from '@mui/material';
import rip from "../assets/rip.png";
const Comingsoon = () => {
    return (
        <Box sx={{ width: "100%", height: "100vh", display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", backgroundColor: "#fff" }}>
            <img loading='lazy' src={rip} alt="rip" style={{ objectFit: "cover" }} />
            <Typography variant="h1" sx={{ color: "#d32f2f", fontSize: "30px", fontWeight: "bold" }}>Coming Soon...</Typography>
        </Box>
    );
};

export default Comingsoon;
